import '../../css/base.css';

const BoatTrips = () => {

  return (
    <div>
      <h2 className="walks-section-heading">Boat Trips</h2>
      <p className="walk-text">It is possible to arrange boat trips across to the golden sands of Barrisdale Bay on Knoydart with
                                a local boatman.  He will drop you for the day and pick up at an arranged time long enough to do some exploring or even 
                                climbing Larven or one of the other munros.  Please contact Peter Fletcher on 01599 235007. 

      </p>                                            
    </div>
  );
}

export default BoatTrips
